// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const OciIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 1522.6 964.4">
    <path
      fill="#ea1b22"
      d="M494.6 964a480.5 480.5 0 0 1-348.1-136.4A481.6 481.6 0 0 1 1.2 482.8 482 482 0 0 1 146.5 138 480.8 480.8 0 0 1 494.6 1.7h559C1179 5 1298.1 57.1 1385.6 147S1522 357.4 1522 482.8c0 125.5-49 246.1-136.5 335.9a480.8 480.8 0 0 1-332 145.3zm546.3-169.4a311 311 0 0 0 226.6-87.6 311.66 311.66 0 0 0 0-447.7 311.4 311.4 0 0 0-226.6-87.6h-534a311.1 311.1 0 0 0-213.6 94.7 311.5 311.5 0 0 0-87.7 216.8c0 80.9 31.4 158.6 87.7 216.8a311.1 311.1 0 0 0 213.6 94.7h534z"
    />
  </svg>,
  "Oci",
);
export default OciIcon;
